import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App redirect-page">
      <div className="redirect-card">
        <img
          src="/logo_gold_gray.png"
          alt="LLMesh logo"
          className="redirect-logo"
        />
        <div className="redirect-brand">LLMesh</div>
        <p className="redirect-subtitle">LLMesh has moved to a new home.</p>
        <a
          className="redirect-btn"
          href="https://qcoda.com/llmesh"
        >
          Go to qcoda.com/llmesh
        </a>
        <p className="redirect-note">Redirecting automatically in 5 seconds…</p>
      </div>
    </div>
  );
}

export default App;
